import Component from './component'

export class Profile extends Component {
  constructor(ctx, ev) {
    super(ctx, ev)

    Object.assign(this.classes, {
      notificationContainer: '.g-notification-container',
    })

    this.hideNotification()
  }

  hideNotification() {
    const DELAY = 5000

    this.$notificationContainer = this.$ctx.find(
      this.classes.notificationContainer
    )

    if (this.$notificationContainer.length > 0) {
      window.setTimeout(() => this.$notificationContainer.hide(), DELAY)
    }
  }

  onResize() {
    // noop
  }
}
